import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  reportCategoryLanguagesLoad,
  reportConversionFunnelLoad,
  reportOssLoad,
  reportPhotoDuplicatesLoad,
  reportProductLanguagesLoad,
  reportProductMetaDescriptionLoad,
  reportProductMetaKeywordsLoad,
  reportProductScoringLoad,
  reportPropertyLanguagesLoad,
  reportPropertyValueLanguagesLoad,
  reportWarehouseCategoryTrendLoad,
  reportWarehouseProductCategorySuggestionLoad,
  reportWarehouseProductChildCategoryEstimateLoad,
  reportWarehouseProductPhotoComparisonLoad,
  reportWarehouseProductsPairingLoad,
  reportWarehouseProductToImportLoad,
  reportWarehouseProductTrendLoad,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(reportCategoryLanguagesLoad.type, send, socket);
  yield takeEvery(reportProductLanguagesLoad.type, send, socket);
  yield takeEvery(reportProductMetaDescriptionLoad.type, send, socket);
  yield takeEvery(reportProductMetaKeywordsLoad.type, send, socket);
  yield takeEvery(reportPhotoDuplicatesLoad.type, send, socket);
  yield takeEvery(reportProductScoringLoad.type, send, socket);
  yield takeEvery(reportPropertyLanguagesLoad.type, send, socket);
  yield takeEvery(reportPropertyValueLanguagesLoad.type, send, socket);
  yield takeEvery(reportWarehouseProductPhotoComparisonLoad.type, send, socket);
  yield takeEvery(reportWarehouseProductToImportLoad.type, send, socket);
  yield takeEvery(reportWarehouseProductTrendLoad.type, send, socket);
  yield takeEvery(reportWarehouseCategoryTrendLoad.type, send, socket);
  yield takeEvery(reportWarehouseProductsPairingLoad.type, send, socket);
  yield takeEvery(
    reportWarehouseProductChildCategoryEstimateLoad.type,
    send,
    socket,
  );
  yield takeEvery(
    reportWarehouseProductCategorySuggestionLoad.type,
    send,
    socket,
  );
  yield takeEvery(reportConversionFunnelLoad.type, send, socket);
  yield takeEvery(reportOssLoad.type, send, socket);
}
